import * as L from 'leaflet'
import { CanvasShipUtils } from '@map-sdk/sdk/utils/CanvasShipUtils'
import { CommUtils } from '@map-sdk/sdk/utils/CommUtils'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'

export interface AreaViewBaseOptions {
  url: string
  isShowName: boolean
  minzoom: number
  maxzoom: number
  colors: string[]
  viewZones: string
  isZoomEnd: boolean
  [key: string]: any
}

class AreaViewBase {
  public options: AreaViewBaseOptions
  protected _isView = false
  protected _map: MyMap
  protected bounds: any[] = []
  protected _areaLayers: L.Layer[] = []
  protected _data: any | undefined // Record<string, SeaMapDataItem[]> | undefined

  constructor(map: MyMap, options?: Partial<AreaViewBaseOptions>) {
    this._isView = true
    this._areaLayers = []
    this._map = map
    this.options = {
      url: '',
      isShowName: true,
      minzoom: 3,
      maxzoom: 9,
      colors: ['#CF0072', '#FFFF33'],
      viewZones: '',
      isZoomEnd: true,
    }

    if (options?.value) {
      this._data = options.value
    }

    L.Util.extend(this.options, options)

    if (this.options.isZoomEnd) {
      this._map.on('zoomend', () => this._showArea())
      this._map.on('baselayerchange', () => this._showArea())
    }
  }

  showArea(): this {
    CanvasShipUtils.openLoadingPopup(50, () => {
      this._isView = true
      this._showArea()
      CanvasShipUtils.closeLoadingPopup()
    })

    return this
  }

  protected _showArea(): this {
    this._hideArea()
    if (
      this._map.getZoom() >= this.options.minzoom &&
      this._map.getZoom() <= this.options.maxzoom &&
      this._isView
    ) {
      if (
        !this._data ||
        (this._data.length === 0 && !CommUtils.isEmpty(this.options.url))
      ) {
        const url = this.options.url.replace(
          '{k}',
          this._map._options?.ak || ''
        )
        console.log('TODO: AreaViewBase', url)
        fetch(url, {
          method: 'GET',
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                `Network response was not ok ${response.statusText}`
              )
            }
            return response.json() // 解析 JSON 数据
          })
          .then((resData) => {
            if (
              resData &&
              typeof resData.status === 'number' &&
              resData.status === 0
            ) {
              this._data = resData.data
            } else if (resData) {
              this._data = resData
            }
            this._map.shipsService?.setZIndex()
            ;(this as any)._show && (this as any)._show()
          })
      } else {
        this._map.shipsService?.setZIndex()
        this.bounds = []
        ;(this as any)._show && (this as any)._show()
      }
      return this
    }
    return this
  }

  hideArea(): this {
    this._isView = false
    this._hideArea()
    return this
  }

  protected _hideArea(): this {
    if (!this._map.areaViewSymbol.hasView()) {
      this._map.shipsService?.restoreZIndex()
    }
    if (this._areaLayers) {
      for (let i = 0; i < this._areaLayers.length; i++) {
        this._map.removeLayer(this._areaLayers[i])
      }
      this._areaLayers = []
    }

    ;(this as any)['_hide'] && (this as any)['_hide']()

    return this
  }

  getViewState(): boolean {
    return this._areaLayers && this._areaLayers.length > 0
  }
}

export { AreaViewBase }
